import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getLocaleFromPathname, withLocale } from '../lib/locale';

export default function NotFound() {
    const locale = getLocaleFromPathname(useLocation().pathname);
    const en = locale === 'en-US';
    const t = (pt, english) => en ? english : pt;
    return <main className="zild-not-found" data-page-not-found>
        <div className="zild-container">
            <span className="zild-not-found__code">404</span>
            <h1>{t('Vamos encontrar o caminho certo.', 'Let’s find the right path.')}</h1>
            <p>{t('Esta página não está disponível neste endereço. Explore a plataforma ou encontre a orientação que precisa nos Docs.', 'This page is not available at this address. Explore the platform or find the guidance you need in Docs.')}</p>
            <div className="zild-not-found__links">
                {[
                    ['/platform', t('Conhecer a plataforma', 'Explore the platform')],
                    ['/docs', t('Buscar na documentação', 'Browse documentation')],
                    ['/blog', t('Ver novidades', 'Explore updates')],
                ].map(([path, label]) => <Link className="zild-btn zild-btn-secondary" key={path} to={withLocale(path, locale)}>{label}<ArrowRight size={16} aria-hidden="true" /></Link>)}
            </div>
        </div>
    </main>;
}
